import {
    Component,
    inject,
    Injectable,
} from '@angular/core';

import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogModule,
    MatDialogRef
} from "@angular/material/dialog";

import {
    FormControl,
    FormGroup,
    ReactiveFormsModule,
    Validators
} from "@angular/forms";

import {
    TranslateModule
} from '@ngx-translate/core';

import {
    MatInputModule
} from '@angular/material/input';

import {
    CommonModule
} from '@angular/common';

import {
    MatButtonModule
} from '@angular/material/button';

import {
    Printers
} from 'tilby-models';

import {
    ConfigurationManagerService
} from "src/app/core/services";

import {
    BaseDialogService,
    NonNullableConfigData
} from '@tilby/tilby-ui-lib/components/tilby-dialog';

import {
    lastValueFrom
} from 'rxjs';

import {
    documentPrinter
} from 'app/ajs-upgraded-providers';

export interface DailyClosingDialogData {
    printer: Printers
}

export interface DailyClosingDialogResult {
    cash_verification: number
}

@Component({
    standalone: true,
    selector: 'app-daily-closing-dialog',
    templateUrl: './daily-closing-dialog.component.html',
    styleUrls: ['./daily-closing-dialog.component.scss'],
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatInputModule,
        ReactiveFormsModule,
        TranslateModule
    ]
})
export class DailyClosingDialogComponent {
    //Injections
    private readonly configurationManagerService = inject(ConfigurationManagerService);
    private readonly dialogRef: MatDialogRef<DailyClosingDialogComponent> = inject(MatDialogRef);
    protected readonly data: DailyClosingDialogData = inject(MAT_DIALOG_DATA);

    protected readonly verifyCashRequired = !!this.configurationManagerService.getPreference('printers.verify_cash_on_dailyclousure');

    protected readonly dailyClosingDialogForm = new FormGroup<{ cashVerification: FormControl<number | null> }>({
        cashVerification: new FormControl(null, [...(this.verifyCashRequired ? [Validators.required] : []), Validators.min(0)])
    });

    get cashVerification() {
        return this.dailyClosingDialogForm.controls.cashVerification;
    }

    answer() {
        if (this.dailyClosingDialogForm.invalid) {
            this.dailyClosingDialogForm.markAllAsTouched();
            return;
        }

        this.dialogRef.close(<DailyClosingDialogResult> {
            cash_verification: this.cashVerification.value!
        });
    }
}
@Injectable({
    providedIn: "root",
})
export class DailyClosingDialogService extends BaseDialogService {
    private dialog = inject(MatDialog);
    private documentPrinterService = inject(documentPrinter);

    public async openDialog(config: NonNullableConfigData<Printers>) {
        const printer = config.data;
        const dailyClosingDialogData: DailyClosingDialogData = { printer };

        const dailyClosingConfig = await lastValueFrom(this.dialog.open<DailyClosingDialogComponent, DailyClosingDialogData, DailyClosingDialogResult | 'cancel'>(DailyClosingDialogComponent, {
            ...this.switchMobileDesktopDimensions({ minWidth: '30vw' }),
            ...config,
            disableClose: true,
            data: dailyClosingDialogData
        }).afterClosed());

        if (dailyClosingConfig && dailyClosingConfig !== 'cancel') {
            return this.documentPrinterService.dailyClosing(printer, dailyClosingConfig);
        }
    }
}
